import { render } from "./NotFound.vue?vue&type=template&id=3227b72b"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__